import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectListView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 2,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 3,
			width: 8,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 8,
			width: 8,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 13,
			width: 8,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 8,
			width: 2,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 13,
			width: 2,
			height: 2,
			fill: "currentColor"
		})
	]
});
export default SvgProjectListView;
